import React from 'react'
import AboutBanner from './about_banner/AboutBanner'
import AboutUSContent from './about_us_content/AboutUSContent'
import OurTeam from './our_team/OurTeam'
import OurSuccessCount from './our_success_count/OurSuccessCount'
import Why_Choose_US from './Why_Choose_US/Why_Choose_US'
import OurPartners from './OurPartners/OurPartners'
import EnquiryFormComponent from './EnquiryFormComponent/EnquiryFormComponent'

export default function AboutUs() {
    return (
        <>
            <AboutBanner />
            <AboutUSContent />
            <OurTeam />
            <OurSuccessCount />
            <Why_Choose_US/>
            <OurPartners/>
            <EnquiryFormComponent/>
        </>
    )
}
